import { TextSelection } from '@remirror/pm/state';
import { Transaction, EditorState } from 'remirror';
/**
 * Replace the current selection with the given replacement text.
 */
export function handleReplaceSelectedText(
  tr: Transaction,
  state: EditorState,
  dispatch: ((tr: Transaction) => void) | undefined,
  replacement: string
): boolean {
  const { from, to, empty } = state.selection;
  if (empty) {
    return false;
  }

  tr.replaceWith(from, to, state.schema.text(replacement));
  tr.setSelection(
    TextSelection.create(tr.doc, from, from + replacement.length)
  );
  tr.setMeta('addToHistory', true);
  dispatch?.(tr);
  return true;
}

/**
 * Wrap the currently selected text in quotes.
 */
export function handleWrapSelectedTextInQuotes(
  tr: Transaction,
  state: EditorState,
  dispatch: ((tr: Transaction) => void) | undefined
): boolean {
  const { from, to, empty } = state.selection;
  if (empty) {
    return false;
  }

  tr.insertText('"', to);
  tr.insertText('"', from);

  tr.setMeta('addToHistory', true);
  dispatch?.(tr);
  return true;
}
